import { dispatch, useReframe } from 'nike-re-framejs';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';

import { scrollBody } from '@/common/client';
import { SEARCH_RESULT_MIN_SIZE } from '@/common/constants';
import { submitSearch } from '../util';
import SearchView, { HistorySuggestions, Suggestions } from './SearchView';
import { updateSearchText } from '@/fullsearch/handlers';
import CommonSearchBox from '@/fullsearch/views/CommonSearchBox';

function SearchBox({ visible, onClose, betbookActive = false }, fwdRef) {
    const [searchText, setSearchText] = useState('');
    const ref = useRef();
    useImperativeHandle(fwdRef, () => ({ focus: () => ref.current.focus() }));

    const derefSub = useReframe();
    const searchAutoSuggest = derefSub(['ui.sectionExpanded', 'searchAutoSuggest', false]);

    function change(value) {
        dispatch(updateSearchText(value));
        setSearchText(value);

        if (value) {
            dispatch(['ui.showSection', 'searchAutoSuggest', true]);
        } else {
            dispatch(['ui.hideSection', 'searchAutoSuggest']);
        }
    }

    function submit(searchText) {
        scrollBody(true);

        if (searchText.length >= SEARCH_RESULT_MIN_SIZE && !betbookActive) {
            submitSearch(searchText);
        }
    }

    return (
        <CommonSearchBox
            betbookActive={betbookActive}
            visible={visible}
            change={change}
            onClose={onClose}
            searchText={searchText}
            formRef={ref}
            submit={submit}
        >
            <SearchView>
                {searchAutoSuggest ? (
                    <Suggestions betbookActive={betbookActive} />
                ) : (
                    <HistorySuggestions onSearchTextUpdate={value => dispatch(updateSearchText(value))} />
                )}
            </SearchView>
        </CommonSearchBox>
    );
}

export default forwardRef(SearchBox);
